import { render, staticRenderFns } from "./CardDiscover.vue?vue&type=template&id=b6c9ea2a&"
import script from "./CardDiscover.vue?vue&type=script&lang=js&"
export * from "./CardDiscover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports